import { Badge } from '@/components/ui/badge'
import { MenuItem } from './SidebarMenu'

import { SidebarIconWrapper } from './SidebarIconWrapper'

interface SidebarItemContentProps {
  item: Pick<MenuItem, 'icon' | 'label' | 'isBeta'>
  active: boolean
}

const SidebarItemContent = ({ item, active }: SidebarItemContentProps) => (
  <span className="flex w-full items-center gap-2">
    <SidebarIconWrapper iconName={item.icon} active={active} />

    <span className="min-w-0 truncate group-data-[collapsible=icon]:hidden">{item.label}</span>

    {item.isBeta && (
      <Badge
        variant="default"
        size="sm"
        className="shrink-0 self-center leading-none group-data-[collapsible=icon]:hidden"
      >
        Beta
      </Badge>
    )}
  </span>
)

export default SidebarItemContent
